import {
  isAsset,
  isBeforeAfterPhoto,
  isGqlImage,
  isMedia,
} from 'types/Utilities';
import type { Asset } from 'contentful';
import type { Slide, Image } from 'types/Utilities';
import type { APIBeforeAfterPhoto } from 'types/BeforeAfterPhotos';
import type { Media } from 'types/Clinic';

/**
 * Find the description based on the slide type
 *
 * @param {Slide} slide
 * @returns {string}
 */
export const findDescription = (slide: Slide): string => {
  if (isMedia(slide)) {
    return (slide as Media).media.description;
  }

  if (isAsset(slide)) {
    return (slide as Asset).fields.description;
  }

  if (isGqlImage(slide)) {
    return (slide as Image).description || (slide as Image).title;
  }

  if (isBeforeAfterPhoto(slide)) {
    return (slide as APIBeforeAfterPhoto).beforeafterphoto?.description || '';
  }

  return '';
};
